import React from 'react';
import {extractInfiniteQueryItems} from '../../../../../../components/pagination/infinite-query-items';
import {isQueryCompleted} from '../../../../utils';
import {useQueryResultsListInfiniteQuery} from './use-query-paths-result-list';

interface Props {
    selectedQuery?: QueryInfo;
}

export function usePathsResultListProps(props: Props) {
    const [selectedResultItem, setSelectedResultItem] = React.useState<number>();

    const queryResultsList = useQueryResultsListInfiniteQuery({
        queryId: props.selectedQuery?.id,
        enabled: !!props.selectedQuery && isQueryCompleted(props.selectedQuery)
    });
    const queryResultsListItems = extractInfiniteQueryItems(
        queryResultsList,
        (response: PageResponse<ConnectionDto, number>) => response.data
    );

    return {
        queryResultsList,
        queryResultsListItems,
        selectedResultItem,
        setSelectedResultItem,
        selectedConnectionIndex: queryResultsListItems?.findIndex(
            (item) => item.id === selectedResultItem
        )
    };
}
